import { Component, EventEmitter, Input, Output } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { RouterModule } from '@angular/router'
import { CommonModule } from '@angular/common'

@Component({
  selector: 'app-back-button',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatTooltipModule, RouterModule],
  template: `
    <ng-container *ngIf="routerLink; else clickButton">
      <button mat-stroked-button [color]="color" [routerLink]="routerLink"><mat-icon>arrow_back</mat-icon> {{ label }}</button>
    </ng-container>
    <ng-template #clickButton>
      <button mat-raised-button [color]="color" (click)="back.emit()" [matTooltip]="tooltip"><mat-icon>arrow_back</mat-icon> {{ label }}</button>
    </ng-template>
  `
})
export class BackButtonComponent {
  @Input() label = 'Voltar'
  @Input() color: 'primary' | 'warn' = 'primary'
  @Input() routerLink?: string
  @Input() tooltip = ''
  @Output() back = new EventEmitter<void>()
}
